import styled from 'styled-components';
import { Button, Modal } from 'reactstrap';

export const StyledModal = styled(Modal)`
  	display: flex;
  	align-items: flex-end;
  	justify-content: center;
`;

export const ModalContent = styled.div`
  	display: flex;
	flex-direction: column;

  	border: none;
  	border-radius: 50px;
  	width: 100%;
  	justify-content: center;
	align-items: center;
	background-color: white;
	padding-top: 50px;
`;

export const ButtonStyle = styled(Button)`
	width: 100%;
	border-radius: 15px;
	border-color: transparent;
`;

export const DivButton = styled.div`
	margin: 0;
	border: none;
`;

export const ImgAlert = styled.img``;

